import {
    METHOD_POST,
    SERVER_URL
} from '../constants/api';
import {  headersAuthSendReceiveJson } from '../headers';
import { apiHandleResponse } from '../../util/api';



export const getAuditLogs = (options) => {
    return fetch(`${SERVER_URL}/api/v1/audit/logs`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};